import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import OrdersActions from "../../../components/User/OrdersInfoComponent/OrdersActions";
import OrdersInfoTable from "../../../components/User/OrdersInfoComponent/OrdersTable";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";

const { getRestaurants } = appActions;

const OrdersInfo = () => {
  const { selectedOrganization } = useProjectState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <>
      <PageHeader text="Справка изпълнение на доставки" date={true} />
      <OrdersActions />
      <OrdersInfoTable />
    </>
  );
};

export default OrdersInfo;
